import { createFileRoute, Link } from "@tanstack/react-router";
import NavbarWebsite from "../components/NavbarWebsite";
import NavbarFooter from "../components/Footer";

import screenshotappUrl from "../assets/img/screenshotapp.png";
import useTranslation from "../hooks/useTranslation";
import { useForm } from "react-hook-form";
import { getCsrfCookie } from "../lib/utils";
import { useState } from "react";

export const Route = createFileRoute("/")({
  component: ChatApp,
});

function ChatApp() {
  const { translate } = useTranslation();

  return (
    <>
      <NavbarWebsite />

      <div className="relative text-black overflow-hidden pb-40">
        {/* Mobile Image */}

        {/* Desktop Image */}

        <div className="relative bg-white overflow-hidden pt-5 md:pt-20 px-4 sm:px-6 pb-20">
          {/* Content wrapper */}
          <div className="relative z-10 w-full max-w-(--breakpoint-xl) mx-auto flex flex-col items-center">
            {/* Text + language list */}
            <div className="w-full lg:w-2/3 text-left">
              <p className="text-3xl sm:text-4xl md:text-4xl font-extrabold leading-tight mb-6 pt-16 font-[TikTok]">
                {translate("landingpage_title")}
              </p>
              <p className="text-xl sm:text-lg md:text-xl font-normal text-gray-600 font-[TikTok] mb-8">
                {translate("landingpage_header_body")}
              </p>
              {/*
               <p className=" sm:text-lg md:text-xl text-gray-600  mb-8">
                {translate("landingpage_header_CTA")}
              </p>
                */}
              {/* 
              <div className="flex flex-col sm:flex-row gap-4 sm:justify-start justify-center">
                <Link
                  to="/free_trial_signup"
                  className="bg-white text-black font-semibold px-6 py-3 rounded-md shadow-sm hover:bg-gray-100 transition text-center"
                >
                  {translate("landingpage_btn_join_waiting_list")}
                </Link>
              </div>

              */}
              <ProgressMail />

              {/* 
              <div className="flex flex-col sm:flex-row gap-4 sm:justify-start justify-center">
                <Link
                  to="/free_trial_signup"
                  className="bg-white text-black font-semibold px-6 py-3 rounded-md shadow-sm hover:bg-gray-100 transition text-center"
                >
                  {translate("landingpage_btn_start_free_trial")}
                </Link>
                <Link
                  to="/pricing"
                  className="border border-white px-6 py-3 rounded-md font-semibold hover:bg-white/10 transition text-center text-white"
                >
                  {translate("landingpage_btn_view_pricing")}
                </Link>
              </div>
              */}
              <p className="text-sm text-black mt-4">
                {translate("no_mobile_app")}
              </p>

              {/*
              {/* Language tags 
              <div className="mt-8 text-sm font-medium text-black">
                <div className="flex flex-col sm:flex-row sm:items-center sm:flex-wrap sm:gap-2">
                  <p className="mb-2 sm:mb-0 sm:mr-2 shrink-0">
                    Available languages:
                  </p>
                  <div className="grid grid-cols-2 sm:flex sm:flex-wrap gap-2">
                    {[
                      "German",
                      "English",
                      "French",
                      "Greek",
                      "Greek (transcript)",
                      "Italian",
                      "Russian",
                      "Russian (transcript)",
                      "Portuguese (Brazil)",
                      "Portuguese (Portugal)",
                      "Spanish",
                    ].map((lang) => (
                      <span
                        key={lang}
                        className=" bg-white  text-black px-3 py-1 rounded-full whitespace-nowrap text-center"
                      >
                        {lang}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
                */}
            </div>

            {/* Screenshot image under language list */}
            <div className="mt-12 w-full flex justify-center">
              <img
                src={screenshotappUrl}
                alt="App screenshot"
                className="w-[90%] max-w-[1000px] h-auto"
              />
            </div>
          </div>
        </div>

        {/* HOW IT WORKS */}
        <section className="bg-white text-black px-4">
          <div className="max-w-6xl mx-auto text-left md:text-center lg:text-center ">
            <h2 className="text-3xl font-bold mb-6">How it works</h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 text-left">
              <div className="p-6 rounded-md shadow-xs border border-gray-200">
                <h3 className="text-lg font-semibold mb-2">
                  Create your own texts
                </h3>
                <p className="text-sm text-gray-800">
                  Enter a topic you love and get a custom text, made just for
                  your level and interests.
                </p>
              </div>
              <div className="p-6 rounded-md shadow-xs border border-gray-200">
                <h3 className="text-lg font-semibold mb-2">Upload images</h3>
                <p className="text-sm text-gray-800">
                  Use your own photos to inspire custom texts based on what’s in
                  the image.
                </p>
              </div>
              <div className="p-6 rounded-md shadow-xs border border-gray-200">
                <h3 className="text-lg font-semibold mb-2">
                  Practice with audio
                </h3>
                <p className="text-sm text-gray-800">
                  Hear your generated text read with natural pronunciation and
                  train your ear as you listen.
                </p>
              </div>

              <div className="p-6 rounded-md shadow-xs border border-gray-200">
                <h3 className="text-lg font-semibold mb-2">
                  Vocabulary trainer
                </h3>
                <p className="text-sm text-gray-800">
                  Learn the words that matter most to you. Save, repeat, and
                  remember them with ease.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-white py-20 px-4 text-black">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-3xl font-bold text-left md:text-center lg:text-center">
              FAQ
            </h2>

            <div className="divide-y divide-gray-200 text-left text-sm sm:text-base">
              <div className="py-4">
                <h3 className="font-semibold mb-1">
                  Do I need to install anything?
                </h3>
                <p className="text-gray-700">
                  No installation needed. This platform works entirely in your
                  browser — on desktop, tablet, or phone.
                </p>
              </div>

              <div className="py-4">
                <h3 className="font-semibold mb-1">
                  Can I use it on my phone?
                </h3>
                <p className="text-gray-700">
                  Yes! It’s fully optimized for mobile. Just open it in your
                  browser — no app store required.
                </p>
              </div>

              <div className="py-4">
                <h3 className="font-semibold mb-1">
                  What language levels are supported?
                </h3>
                <p className="text-gray-700">
                  You can generate content from level A0 (absolute beginner) to
                  C2 (near-native). Perfect for every stage of learning.
                </p>
              </div>

              <div className="py-4">
                <h3 className="font-semibold mb-1">
                  What languages are available?
                </h3>
                <p className="text-gray-700">
                  Currently supported: German, English, French, Greek, Greek
                  (transcript), Russian, Russian (transcript), Portuguese.
                </p>
              </div>

              <div className="py-4">
                <h3 className="font-semibold mb-1">
                  In which countries can I use it?
                </h3>
                <p className="text-gray-700">
                  Anywhere in the world! As long as you have internet and a
                  modern browser, you're good to go.
                </p>
              </div>

              <div className="py-4">
                <h3 className="font-semibold mb-1">
                  What happens after the trial?
                </h3>
                <p className="text-gray-700">
                  After your 14-day free trial, you can choose a plan that fits
                  your learning style — or cancel anytime.
                </p>
              </div>

              <div className="py-4">
                <h3 className="font-semibold mb-1">
                  What if I use up my credits?
                </h3>
                <p className="text-gray-700">
                  You can still access your texts, vocabulary, and trainer — but
                  generating new content or translations will be paused until
                  your next cycle or upgrade.
                </p>
              </div>
            </div>
          </div>
        </section>

        <div className="w-full pb-8 pt-16">
          <div className=" flex flex-col items-center justify-center text-center px-4 ">
            <h2 className="text-4xl font-semibold text-black  mb-4rounded-lg px-4 py-2">
              Make learning feel like yours again.
            </h2>
            <p className="text-xl text-black max-w-2xl mx-auto mb-4 rounded-lg px-4">
              If you’ve ever opened a online learning application and felt
              overwhelmed, annoyed, or just plain bored — I get it. That’s why I
              built this: for people who want more depth, more freedom, and less
              noise.
            </p>
            <div className="flex flex-col md:flex-row gap-4 justify-center mt-6">
              <div className="absolute inset-0 flex justify-center items-center pointer-events-none">
                <div className=" rounded-xl w-full max-w-2xl h-32"></div>
              </div>

              <Link
                to="/pricing"
                className=" text-white bg-black outline-solid outline-1 outline-white backdrop-blur-md font-semibold px-4 py-2 rounded-md shadow-sm hover:bg-white/50 transition"
              >
                View pricing
              </Link>
              <Link
                to="/free_trial_signup"
                className=" text-black backdrop-blur-md bg-white font-semibold px-4 py-2 rounded-md shadow-sm hover:bg-white/50 transition"
              >
                Start free trial
              </Link>
            </div>
          </div>
        </div>
      </div>

      <NavbarFooter />
    </>
  );
}

function ProgressMail() {
  const { translate } = useTranslation();
  const [subscriptionState, setSubscriptionState] = useState<
    "idle" | "submitting" | "success" | "error"
  >("idle");

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
  } = useForm<{ email: string }>();

  const onSubmit = async (data: { email: string }) => {
    setSubscriptionState("submitting");

    try {
      const response = await fetch("/api/reeprise/emailsubscribers/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRFTOKEN": getCsrfCookie(),
        },
        body: JSON.stringify({ email: data.email }),
      });

      if (response.ok) {
        setSubscriptionState("success");
        reset();
        // Reset success state after 3 seconds
        setTimeout(() => setSubscriptionState("idle"), 3000);
      } else {
        setSubscriptionState("error");
        // Reset error state after 5 seconds
        setTimeout(() => setSubscriptionState("idle"), 5000);
      }
    } catch {
      setSubscriptionState("error");
      setTimeout(() => setSubscriptionState("idle"), 5000);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-3">
      <div className="md:flex md:space-x-3 space-y-3 md:space-y-0 items-stretch py-0">
        <div className="flex-1">
          <input
            {...register("email", {
              required: translate("email_subscription_required"),
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: translate("email_subscription_invalid"),
              },
            })}
            type="email"
            placeholder={translate("email_subscription_placeholder")}
            className={`w-full h-full p-3 border rounded-md transition duration-200 ${
              errors.email
                ? "border-red-300 focus:border-red-500 focus:ring-red-200"
                : "border-gray-300 focus:border-blue-500 focus:ring-blue-200"
            } focus:outline-hidden focus:ring-2`}
            disabled={isSubmitting}
          />
          {errors.email && (
            <p className="mt-1 text-sm text-red-600">{errors.email.message}</p>
          )}
        </div>

        <div className="md:w-auto w-full">
          <button
            type="submit"
            disabled={isSubmitting || subscriptionState === "success"}
            className={`w-full h-full p-3 rounded-md font-medium transition duration-200 ${
              subscriptionState === "success"
                ? "bg-green-500 text-white cursor-default"
                : subscriptionState === "error"
                  ? "bg-red-500 hover:bg-red-600 text-white"
                  : isSubmitting
                    ? "bg-gray-400 text-white cursor-not-allowed"
                    : "bg-black hover:bg-gray-600 text-white"
            }`}
          >
            {subscriptionState === "success" &&
              "✓ " + translate("email_subscription_success")}
            {subscriptionState === "error" &&
              translate("email_subscription_error")}
            {isSubmitting && translate("email_subscription_subscribing")}
            {subscriptionState === "idle" && "Notify me when Uxhulu is ready"}
          </button>
        </div>
      </div>
    </form>
  );
}
